import { useEffect, useRef } from 'react'
import { useAuth, useSignInWithLink, useAuthParams } from './index'
import { EMAIL_FOR_SIGN_IN_STORAGE_KEY } from 'config/constants'
import { getReauthenticationVariant } from 'shared/utils'

export const useReauthenticationWithMail = () => {
  const { isAuthenticated } = useAuth()
  const { signInWithLink } = useSignInWithLink()
  const { security, extendSession, reauthenticate } = useAuthParams()
  const reauthenticationStartedRef = useRef(false)
  // A link for deleting the account is always confirmed with the email
  const reauthVariant = getReauthenticationVariant({ security, extendSession })

  useEffect(() => {
    if (!isAuthenticated || !reauthenticate || reauthVariant === null) {
      reauthenticationStartedRef.current = false
      return
    }

    if (reauthenticationStartedRef.current) return

    const email = window.localStorage.getItem(EMAIL_FOR_SIGN_IN_STORAGE_KEY)

    if (!email) return

    reauthenticationStartedRef.current = true

    void signInWithLink(email, window.location.href, true, reauthVariant)
  }, [isAuthenticated, reauthenticate, reauthVariant, signInWithLink])
}
